import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaUsers, FaBookmark, FaLock } from 'react-icons/fa';

const MobileBottomNav = ({ user }) => {
  const location = useLocation();

  const navItems = [
    {
      path: '/skills-feed',
      icon: FaHome,
      label: 'Skills Feed',
      show: true
    },
    {
      path: '/skills-feed/following',
      icon: FaUsers,
      label: 'Following',
      show: user && user.role === 'general'
    },
    {
      path: '/skills-feed/saved',
      icon: FaBookmark,
      label: 'Saved',
      show: true
    },
    {
      path: '/skills-feed/private',
      icon: FaLock,
      label: 'Private',
      show: true
    }
  ];

    const isActive = (path) => {
      if (path === '/skills-feed') {
        return location.pathname === '/skills-feed' || location.pathname === '/';
      }
      return location.pathname === path || location.pathname.startsWith(path + '/');
    };

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 shadow-lg md:hidden"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        borderTop: '1px solid #e5e7eb',
        zIndex: 50,
        boxShadow: '0 -4px 6px -1px rgba(0, 0, 0, 0.1)',
        height: '60px'
      }}
    >
      <div className="flex justify-around items-center py-2 h-full">
        {navItems.map((item) => {
          if (!item.show) return null;
          
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center py-2 px-3 rounded-lg transition-colors ${
                active 
                  ? 'text-primary-700' 
                  : 'text-gray-500 hover:text-primary-700'
              }`}
            >
              <Icon className={`w-5 h-5 mb-1 ${active ? 'text-primary-700' : 'text-gray-500'}`} />
              <span className={`text-xs font-medium font-roboto-flex ${active ? 'text-primary-700' : 'text-gray-500'}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default MobileBottomNav;
